// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/templates",
  ListShort: "/pyr/templates/short",
  Me: "/pyr/templates/me",
  Detail: "/pyr/templates",
  MeDetail: "/pyr/templates/me",
  Create: "/pyr/templates",
  Update: "/pyr/templates",
  DetailField: "/pyr/templates/{id}/fields",
  DetailFieldMe: "/pyr/templates/me/{id}/fields",

  CreateField: "/pyr/templates/{id}/fields",
  CreateGroupField: "/pyr/templates/{id}/group-fields",
  UpdateField: "/pyr/templates/{id}/fields/{fieldId}",
  UpdateFieldBulk: "/pyr/templates/{id}/fields",
  FieldHistoryList: "/pyr/templates/{id}/fields/histories",
  GroupUpdateField: "/pyr/templates/{id}/group-fields/{groupFieldId}",
  GroupUpdateFieldBulk: "/pyr/templates/{id}/group-fields",
  DeleteField: "pyr/templates/{id}/fields/{fieldId}",
  DeleteGroupField: "pyr/templates/{id}/group-fields/{groupFieldId}",

  ImportFieldList: "pyr/payrolls/import-fields",
  ImportParamList: "pyr/payrolls/import-params",
  ImportParamImport: "pyr/payrolls/import-params",

  PrintTemplateList: "/pyr/templates/template-print-samples",
  PrintTemplateCreate: "/pyr/templates/template-print-samples",
  PrintTemplateUpdate: "/pyr/templates/template-print-samples/{id}",
  PrintTemplateDetail: "/pyr/templates/template-print-samples/{id}",
  PrintTemplateDelete: "/pyr/templates/template-print-samples/{id}",
};
